import Modal from "react-modal";

const AnnouncementModal = ({ isOpen, onClose, imageSrc }) => {
  return (
    <Modal
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      onRequestClose={() => onClose(false)}
      contentLabel="Image Modal"
      className="tw-items-center tw-justify-center md:!tw-w-[400px] !tw-w-[300px]"
      overlayClassName="tw-fixed tw-inset-0 tw-bg-black/50 !tw-w-full "
    >
      <div className="tw-flex tw-justify-center tw-relative tw-max-h-[90vh] tw-bg-white tw-rounded-lg tw-p-2">
        <img
          src={imageSrc}
          alt="Example"
          className="tw-w-full tw-max-h-full tw-object-contain"
        />
        <span
          onClick={() => onClose(false)}
          className="material-icons tw-absolute -tw-top-6 -tw-right-6 tw-text-red-500 hover:tw-text-red-700 tw-cursor-pointer"
        >
          cancel
        </span>
      </div>
    </Modal>
  );
};

export default AnnouncementModal;
